import { getLastCustomerMessageByAgent } from '../api/messages';

import {
  setIsSessionTimerLoading,
  setLastMessageTime as setLastMessageTimeAction,
} from '../actions/sessionTimer';

export const setLastMessageTime =
  ({ customerID, agentID, lastMessageTime, useLoading }) =>
  async (dispatch, getState) => {
    if (useLoading) {
      await dispatch(setIsSessionTimerLoading({ isLoading: true }));
    }

    let dispatchPayload = { lastMessageTime };

    if (!lastMessageTime) {
      const lastMessage = await getLastCustomerMessageByAgent({
        customerID,
        agentID,
      });

      dispatchPayload = {
        lastMessageTime: lastMessage?.sent ?? null,
      };
    }

    const currentAgentID = getState().global.curChatAgentID;

    if (agentID === currentAgentID) {
      dispatch(setLastMessageTimeAction(dispatchPayload));
      dispatch(setIsSessionTimerLoading({ isLoading: false }));
    }
  };
